import React, { useState } from "react";
import { FaXmark } from "react-icons/fa6";

function Basket({ change })
{
  const [basket, setBasket] = useState(window.localStorage.getItem('MuckS_Basket'));
  var objBasket = [];

    const handleRemoveItem = (productid) =>
        {
            var tempBasket = [];
            if(basket == null)
            {

            }
            else
            {
              tempBasket = JSON.parse(basket);
            }

            var deletedArray = tempBasket.filter(item => item.id !== productid);

            localStorage.setItem('MuckS_Basket', JSON.stringify(deletedArray));
            setBasket(JSON.stringify(deletedArray));
            change(deletedArray);
            //navigate('../');
    
        }

    if(basket)
    {
      try 
      {
          objBasket = JSON.parse(basket);
      } 
      catch(error) 
      {
          
      }
    }
    const basketItems = objBasket.map((product) =>
        <li className="basketItem" dataid={product.Name}>
           <img alt="basketItem" className="basketImg" src={product.img} />
          <div className="mainBasketPriceContainer">
            <p>{product.Name}</p>
            <p className="basketPrice"> £{product.price}</p>
          </div>
          <div className="basketCrossContainer"><FaXmark color="#eb0029" onClick={() => handleRemoveItem(product.id)}/></div>
        
        </li> 
    );

  return (
    <div className="container">
      <h1>Basket</h1>
        <div>
            <ul className="mainBasketUl">
                {basketItems}
            </ul>
        </div>        
    </div>
  );
}

export default Basket;